export const QUIZ_HUB_PAGE = () => "/operacoes/quiz";
export const QUIZ_NEW_PAGE = () => "/operacoes/quiz/novo";
export const QUIZ_EDIT_PAGE = (id = ":id") => `/operacoes/quiz/${id}/editar`;
export const QUIZ_CAMPAIGN_NEW_PAGE = () => "/operacoes/quiz/campanhas/nova";
export const QUIZ_CAMPAIGN_PAGE = (id = ":id") => `/operacoes/quiz/campanhas/${id}`;
/** Página pública do supervisor: sem login, entra pelo CPF. */
export const QUIZ_PUBLIC_PAGE = (slug = ":slug") => `/quiz/${slug}`;
